import React from "react";
import SectionDivider from "./SectionDivider/SectionDivider";
import { config, useSpring, animated } from "react-spring";
import useWindowDimensions from "../../hooks/useWindowDimension";
import { MD_BREAKPOINT, XL_BREAKPOINT } from "../../config/breakpoints";

const Section = (props) => {
  const { position, title, subtitle, fontSize, showHeader, contentWidth, maxContentWidth } = props;
  const { width } = useWindowDimensions();

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      paddingBottom: 50,
    },
    sectionHeader: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems:
        position === "center"
          ? "center"
          : position === "left"
          ? "flex-start"
          : "flex-end",
      flexDirection: "column",
    },
    sectionBody: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    },
    subtitleTypography: {
      color: "#333333",
      textAlign: position,
      fontWeight: "400",
      fontSize:
        fontSize === "large"
          ? 22
          : fontSize === "medium"
          ? 18
          : fontSize === "small"
          ? 16
          : 22,
      marginTop: 5,
    },
  };

  const titleTypography = useSpring({
    color: "#333333",
    textAlign: position,
    marginBottom: 0,
    paddingBottom: 0,
    fontWeight: "500",
    fontSize:
      fontSize === "large"
        ? width > MD_BREAKPOINT
          ? 32
          : 26
        : fontSize === "medium"
        ? width > MD_BREAKPOINT
          ? 28
          : 22
        : fontSize === "small"
        ? width > MD_BREAKPOINT
          ? 22
          : 18
        : width > MD_BREAKPOINT
        ? 32
        : 26,
    config: config.stiff,
  });

  return (
    <div style={{ ...styles.container, ...props.style }}>
      <div style={{ width: contentWidth ? contentWidth : width > XL_BREAKPOINT ? "75%" : "90%", maxWidth: maxContentWidth }}>
        {showHeader && (
          <div style={styles.sectionHeader}>
            <SectionDivider position={position} />
            <animated.p style={titleTypography}> {title} </animated.p>
            <p style={styles.subtitleTypography}>{subtitle}</p>
          </div>
        )}
        <div style={styles.sectionBody}>{props.children}</div>
      </div>
    </div>
  );
};

export default Section;
